<i (click)="$event.stopPropagation()"
   [cdkCopyToClipboard]="this.data ? this.data : ''"
   class="fa-sharp fa-copy copy-text-icon mg-l-s"
   matTooltip="Copy"></i>
